import { useTranslation } from 'react-i18next'

type AvatarProps = {
  initials?: string
  size?: number
}

export function Avatar({ initials = 'U', size = 32 }: AvatarProps) {
  const { t } = useTranslation('components')

  return (
    <div
      className="avatar"
      aria-label={t('avatar.ariaLabel', { initials })}
      role="img"
      style={{ width: size, height: size }}
    >
      {initials}
    </div>
  )
}
